<div *ngIf="!boards.length" class="alert alert-info">
    <small><i>{{ 'USER_PROFILE.TEXT.NO_BOARDS' | translate }}</i></small>
</div>
<div class="card-body">
    <div class="accordion" id="accordionGroups">

        <div *ngFor="let board of boards; let i = index" class="accordion-item">

            <div (click)="openedBoard[i] = !openedBoard[i]" class="accordion-header">
                <div [attr.aria-controls]="'a' + board.alias"
                     [attr.data-bs-target]="'#a' + board.alias"
                     aria-expanded="false"
                     class="accordion-button collapsed"
                     data-bs-toggle="collapse"
                     type="button"
                >
                    <span>#{{ board.alias + ' ' + board.name }}</span>
                    <div class="ms-2">
                        <button (click)="openPermissions($event, board, permissionsModal)"
                                class="btn btn-sm btn-success">
                            {{ 'USER_PROFILE.TEXT.ACCESS' | translate }}
                        </button>
                        <button (click)="redirectToBoardSettings($event, board)"
                                class="btn btn-sm btn-light me-2 ms-2"
                        >
                            <i class="bi bi-gear-fill"></i>
                        </button>
                    </div>
                </div>
            </div>
            <div [attr.data-bs-parent]="'#a' + board.alias" [id]="'a' + board.alias"
                 class="accordion-collapse collapse overflow-scroll">
                <div class="accordion-body">
                    <ng-container
                            *ngTemplateOutlet="containerTemplate; context: {data: {alias: board.alias, index: i}}">
                    </ng-container>
                </div>
            </div>

        </div>

    </div>
</div>

<ng-template #containerTemplate let-data="data">
    <div *ngIf="data && openedBoard[data.index]" class="dash-list" style="margin-bottom: unset">
        <app-component-tasks-table
                [boardAlias]="data.alias"
                [isMini]="true"
                [emitReload]="emitReloadTasks"
                [personGuid]="profile.guid"
        ></app-component-tasks-table>
    </div>
</ng-template>


<ng-template #permissionsModal let-modal>
    <app-button-modal-close [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <span *ngFor="let permission of permissions">
            <strong>{{ 'TASKS.SETTINGS.ACCESS.' + permission.right | translate }}: </strong>
            <i [class]="selectedBoard.rights[permission.right] ? 'bi bi-check text-success' : 'bi bi-x text-danger'"></i>
            <br>
        </span>
    </div>
</ng-template>
